import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'w-full rounded-md border border-border2 bg-bg px-3 py-2 text-xs font-mono text-ink placeholder:text-muted focus:border-accent focus:outline-none transition-colors',
      className
    )}
    {...props}
  />
))
Input.displayName = 'Input'

export { Input }
